/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';

export interface AuditHistoryQuery {
  pageSize?: number;
  page?: number;
  startDate?: any;
  endDate?: any;
  chartMode?: boolean;
}

export interface AuditHistoryPage {
  results: any[];
  totalCount: number;
}

@Injectable({providedIn: 'root'})
export class AuditHistoryApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(domainObjectId: string, objectType: string | undefined, query: AuditHistoryQuery = {}): Observable<AuditHistoryPage> {
    const params: Record<string, any> = {
      objectType,
      pageSize: query.pageSize || 25,
      page: query.page || 1
    };
    if (query.startDate) {
      params.startDate = query.startDate;
    }
    if (query.endDate) {
      params.endDate = query.endDate;
    }
    if (query.chartMode) {
      params.queryOption = 'SINCE_RUNNING_DATE';
      params.auditType = 'DIRECT_DELIVERY_IMPACT';
    }
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['audithistory', domainObjectId]),
      params
    });
  }
}
